/** Inline US flag, no external image. */
export function UsFlag({ className = "" }: { className?: string }) {
  return (
    <svg viewBox="0 0 2470 1300" width="22" height="12" className={className} aria-hidden="true" focusable="false" preserveAspectRatio="none">
      <defs>
        <path id="us-star" d="M0.00,-40.00L8.98,-12.36L38.04,-12.36L14.53,4.72L23.51,32.36L0.00,15.28L-23.51,32.36L-14.53,4.72L-38.04,-12.36L-8.98,-12.36Z" />
      </defs>
      <rect width="2470" height="1300" fill="#B22234"/>
      <rect y="100.00" width="2470" height="100.00" fill="#ffffff"/>
      <rect y="300.00" width="2470" height="100.00" fill="#ffffff"/>
      <rect y="500.00" width="2470" height="100.00" fill="#ffffff"/>
      <rect y="700.00" width="2470" height="100.00" fill="#ffffff"/>
      <rect y="900.00" width="2470" height="100.00" fill="#ffffff"/>
      <rect y="1100.00" width="2470" height="100.00" fill="#ffffff"/>
      <rect width="988" height="700" fill="#3C3B6E"/>
      <use href="#us-star" x="82.33" y="70.00"/>
      <use href="#us-star" x="247.00" y="70.00"/>
      <use href="#us-star" x="411.67" y="70.00"/>
      <use href="#us-star" x="576.33" y="70.00"/>
      <use href="#us-star" x="741.00" y="70.00"/>
      <use href="#us-star" x="905.67" y="70.00"/>
      <use href="#us-star" x="164.67" y="140.00"/>
      <use href="#us-star" x="329.33" y="140.00"/>
      <use href="#us-star" x="494.00" y="140.00"/>
      <use href="#us-star" x="658.67" y="140.00"/>
      <use href="#us-star" x="823.33" y="140.00"/>
      <use href="#us-star" x="82.33" y="210.00"/>
      <use href="#us-star" x="247.00" y="210.00"/>
      <use href="#us-star" x="411.67" y="210.00"/>
      <use href="#us-star" x="576.33" y="210.00"/>
      <use href="#us-star" x="741.00" y="210.00"/>
      <use href="#us-star" x="905.67" y="210.00"/>
      <use href="#us-star" x="164.67" y="280.00"/>
      <use href="#us-star" x="329.33" y="280.00"/>
      <use href="#us-star" x="494.00" y="280.00"/>
      <use href="#us-star" x="658.67" y="280.00"/>
      <use href="#us-star" x="823.33" y="280.00"/>
      <use href="#us-star" x="82.33" y="350.00"/>
      <use href="#us-star" x="247.00" y="350.00"/>
      <use href="#us-star" x="411.67" y="350.00"/>
      <use href="#us-star" x="576.33" y="350.00"/>
      <use href="#us-star" x="741.00" y="350.00"/>
      <use href="#us-star" x="905.67" y="350.00"/>
      <use href="#us-star" x="164.67" y="420.00"/>
      <use href="#us-star" x="329.33" y="420.00"/>
      <use href="#us-star" x="494.00" y="420.00"/>
      <use href="#us-star" x="658.67" y="420.00"/>
      <use href="#us-star" x="823.33" y="420.00"/>
      <use href="#us-star" x="82.33" y="490.00"/>
      <use href="#us-star" x="247.00" y="490.00"/>
      <use href="#us-star" x="411.67" y="490.00"/>
      <use href="#us-star" x="576.33" y="490.00"/>
      <use href="#us-star" x="741.00" y="490.00"/>
      <use href="#us-star" x="905.67" y="490.00"/>
      <use href="#us-star" x="164.67" y="560.00"/>
      <use href="#us-star" x="329.33" y="560.00"/>
      <use href="#us-star" x="494.00" y="560.00"/>
      <use href="#us-star" x="658.67" y="560.00"/>
      <use href="#us-star" x="823.33" y="560.00"/>
      <use href="#us-star" x="82.33" y="630.00"/>
      <use href="#us-star" x="247.00" y="630.00"/>
      <use href="#us-star" x="411.67" y="630.00"/>
      <use href="#us-star" x="576.33" y="630.00"/>
      <use href="#us-star" x="741.00" y="630.00"/>
      <use href="#us-star" x="905.67" y="630.00"/>
    </svg>
  );
}
